"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _reactChartjs = require("react-chartjs-2");

var _GraphTitle = require("../GraphTitle");

var _utils = require("../utils");

var _Loader = require("../Loader");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var timeIntervalList = ['Day', 'Week', 'Month'];

var NewRegistrationsGraph = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NewRegistrationsGraph, _Component);

  var _super = _createSuper(NewRegistrationsGraph);

  function NewRegistrationsGraph(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NewRegistrationsGraph);
    _this = _super.call(this, props);
    _this.state = {
      selectedItem: timeIntervalList[0],
      isLoading: true,
      graphData: []
    };
    _this.handleIntervalSelection = _this.handleIntervalSelection.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchNewRegistrations = _this.fetchNewRegistrations.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(NewRegistrationsGraph, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchNewRegistrations();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(prevProps) {
        var prevStartDate, prevEndDate, prevSelectedRoles, prevSelectedRanks, _this$props, startDate, endDate, selectedRoles, selectedRanks;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                prevStartDate = prevProps.startDate, prevEndDate = prevProps.endDate, prevSelectedRoles = prevProps.selectedRoles, prevSelectedRanks = prevProps.selectedRanks;
                _this$props = this.props, startDate = _this$props.startDate, endDate = _this$props.endDate, selectedRoles = _this$props.selectedRoles, selectedRanks = _this$props.selectedRanks;

                if (!(prevStartDate.toString() !== startDate.toString() || prevEndDate.toString() !== endDate.toString() || prevSelectedRoles !== selectedRoles || prevSelectedRanks !== selectedRanks)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return this.fetchNewRegistrations();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchNewRegistrations",
    value: function () {
      var _fetchNewRegistrations = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var res;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context3.prev = 1;
                _context3.next = 4;
                return this.props.fetchData('/analyticsV2/fetchNewRegistrationsOverTime');

              case 4:
                res = _context3.sent;
                this.setState({
                  isLoading: false,
                  graphData: res.data
                });
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                this.setState({
                  isLoading: false
                });
                console.log('error: ', _context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function fetchNewRegistrations() {
        return _fetchNewRegistrations.apply(this, arguments);
      }

      return fetchNewRegistrations;
    }()
  }, {
    key: "handleIntervalSelection",
    value: function handleIntervalSelection(e) {
      var target = e.target;
      this.setState({
        selectedItem: target === null || target === void 0 ? void 0 : target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var shouldChartRedraw = this.props.shouldChartRedraw;
      var _this$state = this.state,
          graphData = _this$state.graphData,
          isLoading = _this$state.isLoading;
      return (0, _preact.h)("div", {
        className: "graph-row"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "New registrations",
        tooltipMessage: "The number of new registrations in the selected time period."
      }), isLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_reactChartjs.Bar, {
        redraw: shouldChartRedraw,
        data: (0, _utils.getBarChartDataDataSet)(graphData, 'New registrations'),
        options: (0, _utils.getBarChartOptions)(false)
      }));
    }
  }]);
  return NewRegistrationsGraph;
}(_preact.Component);

exports.default = NewRegistrationsGraph;